import { motion } from 'framer-motion';

const qualifiers = [
  {
    icon: 'ri-timer-flash-line',
    text: 'Necesitas resolver la herencia de forma rápida y sin demoras',
  },
  {
    icon: 'ri-building-2-line',
    text: 'Hay varios bienes involucrados: propiedades, vehículos, cuentas bancarias',
  },
  {
    icon: 'ri-shield-check-line',
    text: 'Quieres evitar errores o rechazos en el trámite',
  },
  {
    icon: 'ri-user-delegate-line',
    text: 'Prefieres delegar todo el proceso legal sin tener que ir a oficinas',
  },
];

const PosesionForWho = () => {
  const scrollToForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.getElementById('posesion-efectiva-form');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left — content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="inline-block bg-black text-primary-yellow text-xs font-black uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">
              Para quién es
            </span>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-black leading-tight mb-6">
              Este servicio
              <br />
              <span className="text-primary-yellow">es para ti si:</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-10">
              Trabajamos con personas que necesitan gestionar una herencia con seriedad y sin complicaciones. Si te identificas con alguna de estas situaciones, podemos ayudarte.
            </p>

            {/* Qualifier list */}
            <div className="space-y-4">
              {qualifiers.map((q, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.1, duration: 0.5 }}
                  className="flex items-center gap-4 bg-gray-50 rounded-xl px-5 py-4 border border-gray-100"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-yellow rounded-lg flex-shrink-0">
                    <i className={`${q.icon} text-black text-lg`}></i>
                  </div>
                  <p className="text-gray-700 text-sm font-medium leading-snug">{q.text}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right — filter box */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <div className="bg-black rounded-3xl p-10 flex flex-col gap-8">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-primary-yellow rounded-2xl flex-shrink-0">
                  <i className="ri-briefcase-3-line text-black text-2xl"></i>
                </div>
                <div>
                  <p className="text-primary-yellow text-xs font-black uppercase tracking-widest mb-1">Servicio profesional</p>
                  <h3 className="text-white text-xl font-extrabold leading-snug">Evaluamos cada caso individualmente</h3>
                </div>
              </div>

              <p className="text-gray-400 text-sm leading-relaxed border-t border-white/10 pt-6">
                Este es un servicio profesional pagado. Evaluamos cada caso para entregarte una solución clara y completa, con respaldo de abogados y procesos estructurados.
              </p>

              <div className="space-y-3">
                {[
                  { icon: 'ri-checkbox-circle-line', text: 'Diagnóstico inicial de tu situación' },
                  { icon: 'ri-checkbox-circle-line', text: 'Proceso gestionado de inicio a fin' },
                  { icon: 'ri-checkbox-circle-line', text: 'Sin trámites que debas hacer tú' },
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-primary-yellow text-base`}></i>
                    </div>
                    <span className="text-gray-300 text-sm">{item.text}</span>
                  </div>
                ))}
              </div>

              <a
                href="#posesion-efectiva-form"
                onClick={scrollToForm}
                className="w-full bg-primary-yellow text-black px-8 py-4 rounded-full font-bold text-base hover:bg-yellow-400 transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
              >
                Evaluar mi caso
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PosesionForWho;
